"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeTransformStruct = void 0;
const utils_1 = require("../../../utils");
function safeTransformStruct(struct) {
    if ((0, utils_1.isConcurrentStruct)(struct)) {
        return Object.assign(Object.assign({}, struct), { chainId: struct.chainId.toString() });
    }
    else {
        return Object.assign(Object.assign({}, struct), { chainId: struct.chainId.toString(), userNonce: struct.userNonce.toString() });
    }
}
exports.safeTransformStruct = safeTransformStruct;
